import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/website/`;

const getWebsites = async () => {
    return await axios.get(API_URL);
};

const addWebsite = async (websiteData) => {
    return await axios.post(API_URL, websiteData);
};

const editWebsite = async (websiteId, updatedData) => {
    return await axios.put(API_URL + websiteId, updatedData);
};

const deleteWebsite = async (websiteId) => {
    return await axios.delete(API_URL + websiteId);
};

export default {
    getWebsites,
    addWebsite,
    editWebsite,
    deleteWebsite
};
